module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    staticStyle: {
      "background": "#aa076b"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container gw-mtp4"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(6)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(8)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner-style-one home-page-two banner-hero",
    attrs: {
      "id": "banner"
    }
  }, [_c('span', {
    staticClass: "bubble-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-3"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-4"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-6"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "banner-hero-img-1 banner-mock",
    attrs: {
      "src": "/static/assets/images/banner-moc-1-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-lg-8 banner-hero-intro"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('h3', {
    staticClass: "gw-not-mobile",
    staticStyle: {
      "font-size": "38px",
      "margin-bottom": "-8px"
    }
  }, [_vm._v("Show your Best with the Best.")]), _vm._v(" "), _c('div', {
    staticClass: "hero-mobile"
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "15em"
    },
    attrs: {
      "src": "/static/assets/images/banner-mobile-2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Capture your moments "), _c('br'), _vm._v(" Save, Organise and "), _c('br'), _vm._v(" Make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn lengthy",
    attrs: {
      "href": "/demos"
    }
  }, [_c('span', [_vm._v("View Live  Demos")])]), _vm._v(" "), _c('a', {
    staticClass: "banner-btn shorty",
    attrs: {
      "href": "/go/pricing"
    }
  }, [_c('span', [_vm._v("Purchase")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-style-one",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "image-block"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banner-mobile.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-title "
  }, [_c('h2', [_vm._v("Showcase your awesome designs "), _c('br'), _vm._v(" with your Gallery Website.")])]), _vm._v(" "), _c('p', [_vm._v("We live in a visual world - "), _c('br'), _vm._v(" Make it easier for Clients to find and choose you. ")]), _vm._v(" "), _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Choose a plan and create an account  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Arrange and organise your Services into Lookbooks")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Upload and describe Products and Services in Posts")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Easy to use Admin Area")])]), _vm._v(" "), _c('a', {
    staticClass: "feature-btn",
    attrs: {
      "href": "#more"
    }
  }, [_vm._v("Learn More")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 2 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Nil Custom domain ")]), _vm._v(" "), _c('li', [_vm._v("Nil custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or video")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl security")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl Security")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gw-customize",
    staticStyle: {
      "background-color": "#f7fbff"
    }
  }, [_c('div', {
    staticClass: "container subscribe-style-one"
  }, [_c('h2', {
    staticClass: "text-center gw-mtp3",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Customize your Gallery with your own designs.")]), _vm._v(" "), _c('form', {
    staticClass: "subscribe-form",
    staticStyle: {
      "margin-bottom": "-1em"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Interested? Enter your email, we will contact you"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Yes I'm Interested")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "faq-style-one",
    attrs: {
      "id": "more"
    }
  }, [_c('div', {
    staticClass: "container gw-mtp3"
  }, [_c('div', {
    staticClass: "block-title text-center gw-mtp2"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "-1em"
    }
  }, [_vm._v("Frequently Asked Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-grp",
    attrs: {
      "data-grp-name": "faq-accrodion"
    }
  }, [_c('div', {
    staticClass: "accrodion active"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v(" What is a Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Gallery Websites are simple, visual focused websites with products arranged like you wouldin a Product Catalogue with ecommerce functionality. The concept is that of the Fashion Lookbook\r\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("How does one get a Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("It’s simple. Just choose from any of our 3 plans above, subscribe, create an account and get started")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("What happens when my subscription expires?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Your account is archived for a month and permanently deleted afterwards if no further actionis taken. But if you wish to keep your contents/posts, you can pay for your Gallery Website to remain archived until the day you decide to make it Live again. "), _c('br'), _vm._v("Don’t worry, we would send you reminders.\r\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("How do I receive payments from Clients?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Payments on each Gallery Website is directly to the Site owner via an online payment gateway which we would help you setup but would be managed solely by you.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Will my website have my company name as the domain e.x www.mycompany.com?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, all our paid plans have free custom .com.ng domains but you can easily pay for any domain of your choice to be added - .com, .ng etc")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Will I be able to upload my products?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, every account has its own Admin area where you have "), _c('b', [_vm._v("full control over your Gallery Website’s Look and Feel")]), _vm._v(" - manage your product and shipping details, upload and change images, update your Contact Us info etc.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Do you provide shipping partners?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("No, we don’t. It’s the responsibility of each Gallery Website owner to handle his/her shipping responsibilities. But feel free to browse through our Logistics category in ‘Our Gallery’ to find a shipping partner that sits your needs.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Do I get unlimited Storage space on my Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("No, every plan is capped but you can expand your space for an additional unremarkable yearly fee")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("I have a domain and hosting already, can my Gallery Website be moved there?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Unfortunately, this service is not yet available for now. All Gallery Websites are managed from a central host but you can use your already purchased domain name for your Gallery Website.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Can I have some additional features added to my Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, you can. Just write to the team at "), _c('a', {
    attrs: {
      "href": "mailto:customfeatures@lookbookgallery.com"
    }
  }, [_vm._v("customfeatures@lookbookgallery.com")]), _vm._v(" and start the discussion on how we can build you a custom Gallery Website")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("I have registered and logged in, but don’t know what to do next?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Please watch our "), _c('b', [_vm._v("onboarding videos")]), _vm._v(" or read through our "), _c('b', [_vm._v("‘Getting Started Tutorials’")]), _vm._v(" to serve as a guide. And if you are still not clear on what to do next, you can give us a call on 0708 642 8158 or send us a mail at "), _c('a', {
    attrs: {
      "href": "mailto:onboarding@lookbookgallery.com"
    }
  }, [_vm._v("onboarding@lookbookgallery.com")]), _vm._v(" to guide you through the process")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b65efc1c"}!./src/pages/GetStarted/template.html
// module id = 260
// module chunks = 0